import React from "react";
import { useSelector } from "react-redux";
import { useMediaQuery } from "react-responsive";
import BreakPoints from "../../constants/breakpoints";
import leftArrowIcon from "../../img/icons/left-arrow-nav.svg";
import localization from "../../data/config";
import { BREADCRUMB_URL, GENERIC_TOKEN } from "../../constants/config/parts";
import "./style.css";

/**
 * @name Title
 * @function
 * @description Displays PST title
 * @returns {JSX}
 * @param {*} props
 */
const Title = () => {
  const breadCrumbUrl = useSelector((state) => state.app.breadCrumbUrl),
    title = useSelector((state) => state.app.title),
    lastBreadcrumb = breadCrumbUrl[breadCrumbUrl.length - 1],
    isMobile = useMediaQuery({ maxWidth: BreakPoints.mobile.max });

  return (
    <>
      {
        isMobile 
          ? <>
              <div className="backtoMenu">
                  <a href={BREADCRUMB_URL.replace(GENERIC_TOKEN, lastBreadcrumb.url)}>
                    <img src={leftArrowIcon} alt="Left Arrow" />
                    <span className="backtoNav"
                      dangerouslySetInnerHTML=
                      {{ __html: `${localization.backToLabel} ${lastBreadcrumb.name}` }} />
                  </a>
              </div>
              <div className="mgmoble"></div>
              <header className="mobileHeading" id="pst-feature">
                <h1 dangerouslySetInnerHTML={{ __html: title }} />
              </header>
            </> 
          : <div className="title__container">
              <div className="title__wrapper">
                <header className="title">
                  <h1 dangerouslySetInnerHTML={{ __html: title }} />
                </header>
              </div>
            </div>
      }
    </>
  );
};

export default Title;
